import { createContext } from 'react';

import type { CalendarMoveRecordState } from '@app/providers/CalendarProvider/CalendarMoveRecordContext.types';

export const CalendarMoveRecordContext = createContext<CalendarMoveRecordState>(
  {
    canMoveRecord: false,
    canMoveMessage: '',
    isModalOpen: false,
    setIsModalOpen: () => {},
    notificationModal: {
      submitHandler: () => {},
      cancelHandler: () => {},
    },
    setNotificationModalSubmitHandler: () => {},
    setNotificationModalCancelHandler: () => {},
    updateCalendarDataWithNewRecord: () => {},
    checkIfCanMoveRecord: () => {},
  }
);
